import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';
import * as fileSaver from 'file-saver';


@Component({
  selector: 'app-payment-detail',
  templateUrl: './payment-detail.component.html',
  styleUrls: ['./payment-detail.component.css']
})
export class PaymentDetailComponent implements OnInit {
  env = environment;

  ulb_id: any = '';
  ulb_data: any = [];
  paymentHistory: any = [];
  paymentLedger: any = [];
  user_details: any = [];
  user_dtl: any = [];
  name = '';
  email = '';
  mobile_no = '';
  isMessageShow = false;
  p_items: any;
  isActive = 'payment_history';
  payment_history = true;
  payment_ledger = false;
  prop_id = '';


  constructor(private apiService : ApiService, 
    private appComponent: AppComponent,
    private activatedRoute: ActivatedRoute,  private router: Router) { }

  ngOnInit(): void {
    this.prop_id = this.activatedRoute.snapshot.params['id'];

    // this.getUlbDataList();
    this.paymentDetail();
    if(this.env.environmentName = "srinagar"){
        this.ulb_id = this.env.ulb_id;
    }

    this.user_details = localStorage.getItem("loginDetails");
    if(this.user_details == null){
      this.router.navigate(['/login'], { queryParams: { returnUrl: '/user-property-list' }});
    }
    this.user_dtl = JSON.parse(this.user_details).user[0];
    this.name= this.user_dtl.name;
    this.email= this.user_dtl.email;
    this.mobile_no= this.user_dtl.mobile_no;

  }

  handleItem(category : any){
    this.isActive = category;
    if(category === 'payment_history'){
      this.payment_history = true;
      this.payment_ledger = false;
    }
    else if(category === 'payment_ledger'){
      this.payment_ledger = true;
      this.payment_history = false;
    }
   }

  // getUlbDataList(){
  //   this.apiService.getCitizenData(`public_ulbs`).subscribe((res) =>{
  //     this.ulb_data = res.data;
  //   },
  //   (error) => {
  //     this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
  //   })
  // }

  paymentDetail(){
    this.appComponent.showLoader();
    this.apiService.getCitizenData(`payment_history?service_type_id=&start_date=&end_date=&property_id=${this.prop_id}`).subscribe(
      (res:any) =>{
      this.paymentHistory = res['data'];
      this.appComponent.hideLoader();
    },
    (error) => {
      this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
      this.appComponent.hideLoader();
    })

    this.apiService.getCitizenData(`ledger?service_type_id=&start_date=&end_date=&property_id=${this.prop_id}`).subscribe(
      (res:any) =>{
      this.paymentLedger = res['data'];
      this.appComponent.hideLoader();
    },
    (error) => {
      this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
      this.appComponent.hideLoader();
    })
  }

  logout(){
    this.appComponent.logout();
  }

  downloadReceipt(_payment_receipt: any){

    this.appComponent.showLoader();
    let receipt_url = _payment_receipt;
    fileSaver.saveAs(receipt_url, `payment_receipt.pdf`);
    this.appComponent.hideLoader();

    // this.apiService.getCitizenData(`download_receipt/113605`).subscribe(
    //   (res:any) =>{
    //     this.apiService.getBlobFileFromServer(`${res}`).subscribe(res => {
    //       this.appComponent.hideLoader();
    //       let blob:any = new Blob([res], { type: res.type });
    //       fileSaver.saveAs(blob, fileName[1]);
    //     });   
    //       this.appComponent.hideLoader();
    // },
    // (error) => {
    //   this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
    //   this.appComponent.hideLoader();
    // })
    

  }
}